// --------------------------------------------------------
// CARD PAINEL CONSULTS - CardPainelConsults
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Avatar } from "@mui/material";
import React, { useState } from "react";
import {
  ContainerPainelConsults,
  DivName,
  DivProntuario,
  DivTipo,
  NamePacient,
} from "./CardPainelConsults.styled";
import Colors from "../../constants/Colors";
import { ReactComponent as Clock } from "../../assets/imgs/clockIcon.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AppointmentAttendance from "../appointmentAttendance/AppointmentAttendance";
import CardPainelConsultsModal from "./CardPainelConsultsModal";
import { convertDayToMoment } from "../../helpers/HelperFunctions";
import { utils } from "@hassanmojab/react-modern-calendar-datepicker";
import {
  HourContainer,
  MobileContainer,
} from "../../pages/appointmentPanel/AppointmentPanel.styled";
import { Text } from "../UI/generalLayout/Layout.styled";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../enums/Paths";
import useFetchPhoto from "../../hooks/useFetchPhoto";
import moment from "moment";
import { AppointmentStatus } from "../../enums/AppointmentStatus";
import * as appointmentActions from "../../store/actions/appointment";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import * as medicalRecordAction from "../../store/actions/medicalRecord";
import { useAppDispatch } from "../..";
import { atualizaAcessoProntuario } from "../../store/actions/person";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARD PAINEL CONSULTS INTERFACE
// --------------------------------------------------------

interface ICardPainelConsults {
  status?: any;
  data: any;
  onChangeAppointmentStatus: () => void;
  isTodaysAppointments: boolean;
  profissional: any;
}

export interface PessoaPainel {
  pessoaId: string;
  nome: string;
  comoSerChamado: string;
  cpf: string;
  foto: string;
  genero: string;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardPainelConsults = ({
  status,
  data,
  isTodaysAppointments,
  onChangeAppointmentStatus,  
  profissional
}: ICardPainelConsults) => {
  // --------------------------------------------------------
  // CARD PAINEL CONSULTS PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [modalScheduling, setModalScheduling] = useState(false);
  const [photo, setPhoto] = useState<any>();
  const { isMobile } = useResponsiveInfo();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const date = convertDayToMoment(utils("en").getToday());

  const pessoa: PessoaPainel = data;
  const isEncaixe = data.encaixe;
  const horario = moment(data.horario, "YYYY-MM-DDTHH:mm").format("HH:mm");

  useFetchPhoto(data.foto, setPhoto);

  const navigateToProntuario = async (pessoa: any) => {
    await dispatch(
      appointmentActions.fetchAppointmentsByPacienteId(pessoa.idPessoa, horario)
    );

    dispatch(atualizaAcessoProntuario(false));

    navigate(Paths.Prontuario, {
      state: {
        pessoa: pessoa,
        horario: horario,
        agendamento: data,
        isRealizado: data.statusPresenca,
      },
    });
  };
  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {!isMobile && (
        <ContainerPainelConsults status={isEncaixe}>
          <DivName>
            <Avatar src={photo} />
            {status ? (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    justifyContent: "start",                    
                  }}
                >
                  <NamePacient>{pessoa.nome ? pessoa.nome : pessoa.comoSerChamado}</NamePacient>

                  {isEncaixe && (
                    <Text
                      style={{
                        fontSize: 13,
                        color: Colors.SPM600,
                        marginTop: -5,
                        marginBottom: 5,
                        marginLeft: 10,
                      }}
                    >
                      Encaixe
                    </Text>
                  )}
                </div>
              </>
            ) : (
              <NamePacient>{pessoa.nome ? pessoa.nome : pessoa.comoSerChamado}</NamePacient>
            )}
          </DivName>
          <HourContainer>
            <Clock />
            <Text style={{ fontSize: 14, marginLeft: 5, color: Colors.SPM600 }}>
              {horario}
            </Text>
          </HourContainer>
          <DivTipo>{`Consulta ${data.tipoConsulta}`}</DivTipo>
          <DivTipo>{`${profissional}`}</DivTipo>
          <DivProntuario
            onClick={
              isTodaysAppointments
                ? () => {
                    navigateToProntuario(pessoa);
                  }
                : () => {}
            }
          >
            {"PRONTUÁRIO"}
            <ArrowForwardIosIcon style={{ fontSize: 14, marginRight: 10 }} />
          </DivProntuario>          
          <AppointmentAttendance
            selectedDate={date}
            status={data.statusPresenca ?? ""}
            onChangeStatus={() => setModalScheduling(true)}
          />

        </ContainerPainelConsults>
      )}
      {isMobile && (
        <>
          <MobileContainer
            style={{ backgroundColor: isEncaixe ? "#E7F3FD" : "#FAFAFA" }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flexDirection: "row", display: "flex" }}>
                <Avatar style={{ marginTop: 5, marginRight: 8 }} src={photo} />
                {!isEncaixe && <Text>{pessoa.nome ? pessoa.nome : pessoa.comoSerChamado}</Text>}
                {isEncaixe && (
                  <div style={{ flexDirection: "column", display: "flex" }}>
                    <Text style={{ marginTop: isEncaixe ? 10 : 0 }}>
                      {pessoa.nome ? pessoa.nome : pessoa.comoSerChamado}
                    </Text>
                    <Text
                      style={{
                        fontSize: 13,
                        color: Colors.SPM600,
                        marginTop: -15,
                        marginBottom: 20,
                      }}
                    >
                      Encaixe
                    </Text>
                  </div>
                )}
              </div>
              <HourContainer>
                <Clock />
                <Text
                  style={{ fontSize: 14, marginLeft: 5, color: Colors.SPM600 }}
                >
                  {horario}
                </Text>
              </HourContainer>
            </div>
            <Text>{`Consulta ${data.tipoConsulta}`}</Text>
            <Text>{`${profissional}`}</Text>
            <AppointmentAttendance
              selectedDate={date}
              status={data.statusPresenca ?? ""}
              onChangeStatus={() => setModalScheduling(true)}
            />
            <DivProntuario
              onClick={
                isTodaysAppointments
                  ? () => {
                      navigateToProntuario(pessoa);
                    }
                  : () => {}
              }
            >
              {"PRONTUÁRIO"}
              <ArrowForwardIosIcon style={{ fontSize: 14, marginRight: 10 }} />
            </DivProntuario>
          </MobileContainer>
        </>
      )}
      <CardPainelConsultsModal
        modalOpen={modalScheduling}
        onCloseModal={() => setModalScheduling(false)}
        onSaveStatus={() => {
          onChangeAppointmentStatus();
        }}
        data={data}
        photo={photo}
      />
    </>
  );
  // --------------------------------------------------------
};

export default CardPainelConsults;
